import React, { useState, useRef } from 'react';
import { Scanner } from '@yudiel/react-qr-scanner';
import Webcam from 'react-webcam';
import axios from 'axios';
import { useEffect } from 'react';

const UploadPhoto = () => {
    const [qrData, setQrData] = useState('');
    const [photoUri, setPhotoUri] = useState('');
    const webcamRef = useRef(null);
    const [cameraAllowed, setCameraAllowed] = useState(null);

    useEffect(() => {
        const checkCameraPermission = async () => {
            try {
                if (navigator.permissions) {
                    const status = await navigator.permissions.query({ name: 'camera' });
                    setCameraAllowed(status.state === 'granted');
                    status.onchange = () => {
                        setCameraAllowed(status.state === 'granted');
                    };
                }
            } catch (err) {
                console.error('Permission check failed:', err);
                setCameraAllowed(false);
            }
        };
        checkCameraPermission();
    }, []);

    const capturePhoto = () => {
        if (webcamRef.current) {
            const isMobile = window.innerWidth < 768;
            let width, height;

            if (isMobile) {
                width = 1080;
                height = 1920;
            } else {
                width = 1920;
                height = 1080;
            }

            const imageSrc = webcamRef.current.getScreenshot();

            setPhotoUri(imageSrc);
        }
    };



    const handleSubmit = async () => {
        if (!qrData || !photoUri) {
            alert("Please scan QR and capture photo first.");
            return;
        }

        try {
            const response = await axios.post('https://kcexpo.samaksh.in/api/upload-image', {
                barcode: qrData,
                image: photoUri,
            });

            if (response.status === 200) {
                alert("Data submitted!");
                setQrData('');
                setPhotoUri('');
            } else {
                throw new Error(response.data);
            }
        } catch (error) {
            console.error("Submission error:", error);
            alert(`Error occurred: ${error.response?.data?.message || error.message}`);
        }
    };

    const videoConstraints = {
        facingMode: "environment",
        imageSmoothing: true,
        forceScreenshotSourceSize: true,
        screenshotQuality: 1
    };




    return (
        <div className="container my-5">
            <div className="row justify-content-center">
                <div className="col-12 col-md-8">
                    <h2 className="text-center mb-3">Scan QR Code</h2>

                    {/* QR Scanner */}
                    {!qrData && (
                        <div className="d-flex justify-content-center mb-4">
                            <div
                                className="border rounded shadow"
                                style={{ width: '100%', maxWidth: '400px', height: '300px' }}
                            >
                                <Scanner
                                    onScan={(result, error) => {
                                        if (result) setQrData(result[0]?.rawValue);
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    {/* Show after QR scanned */}
                    {qrData && (
                        <>
                            <div className="text-center mb-3">
                                <p><strong>Scanned Data:</strong> {qrData}</p>
                            </div>

                            {/* Webcam */}
                            {!photoUri && (
                                <div className="col d-flex flex-column align-items-center mb-3">
                                    <div
                                        className="border rounded shadow overflow-hidden mb-3"
                                        style={{ width: '100%', maxWidth: '400px', aspectRatio: '1 / 1' }}
                                    >
                                        <Webcam
                                            audio={false}
                                            ref={webcamRef}
                                            screenshotFormat="image/jpeg"
                                            className="w-100 h-100 object-fit-cover"
                                            videoConstraints={videoConstraints}
                                        />
                                    </div>

                                    <div className="text-center">
                                        <button
                                            onClick={capturePhoto}
                                            className="btn btn-primary"
                                        >
                                            Capture Photo
                                        </button>
                                    </div>
                                </div>

                            )}

                            {/* Captured photo */}
                            {photoUri && (
                                <div className="text-center mb-3">
                                    <p className="text-success fw-semibold">Photo Captured!</p>
                                    {/* <div
                                        className="border rounded shadow overflow-hidden mx-auto"
                                        style={{ width: '100%', maxWidth: '400px', aspectRatio: '1 / 1' }}
                                    > */}
                                    <img
                                        src={photoUri}
                                        alt="Captured"
                                        style={{ maxWidth: '500px', width: '100%' }}
                                        className="img-fluid img-thumbnail rounded mx-auto d-block"
                                    />

                                    {/* </div> */}
                                </div>
                            )}

                            {/* Submit Button */}
                            {photoUri && (
                                <div className="text-center">
                                    <button onClick={handleSubmit} className="btn btn-success">
                                        Submit Data
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UploadPhoto;